var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFernsMosses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48,92 C50,72 52,50 58,28",
    fill: "none",
    stroke: "#558B2F",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(38 48.8 81.3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.7,
    cy: 81.3,
    rx: 12.2,
    ry: 5.1,
    fill: "#8BC34A",
    stroke: "#558B2F",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-38 48.8 81.3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 61,
    cy: 81.3,
    rx: 12.2,
    ry: 5.1,
    fill: "#8BC34A",
    stroke: "#558B2F",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(38 50.5 72.0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 72,
    rx: 10.5,
    ry: 4.6,
    fill: "#8BC34A",
    stroke: "#558B2F",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-38 50.5 72.0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 61,
    cy: 72,
    rx: 10.5,
    ry: 4.6,
    fill: "#8BC34A",
    stroke: "#558B2F",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(38 52.2 62.7)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.3,
    cy: 62.7,
    rx: 8.8,
    ry: 4.1,
    fill: "#8BC34A",
    stroke: "#558B2F",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-38 52.2 62.7)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 61,
    cy: 62.7,
    rx: 8.8,
    ry: 4.1,
    fill: "#8BC34A",
    stroke: "#558B2F",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(38 53.8 53.3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.7,
    cy: 53.3,
    rx: 7.2,
    ry: 3.5,
    fill: "#8BC34A",
    stroke: "#558B2F",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-38 53.8 53.3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 61,
    cy: 53.3,
    rx: 7.2,
    ry: 3.5,
    fill: "#8BC34A",
    stroke: "#558B2F",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(38 55.5 44.0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 44,
    rx: 5.5,
    ry: 3,
    fill: "#8BC34A",
    stroke: "#558B2F",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-38 55.5 44.0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 61,
    cy: 44,
    rx: 5.5,
    ry: 3,
    fill: "#8BC34A",
    stroke: "#558B2F",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(38 57.2 34.7)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.3,
    cy: 34.7,
    rx: 3.8,
    ry: 2.5,
    fill: "#8BC34A",
    stroke: "#558B2F",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-38 57.2 34.7)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 61,
    cy: 34.7,
    rx: 3.8,
    ry: 2.5,
    fill: "#8BC34A",
    stroke: "#558B2F",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58,28 a5.5,5.5 0 1 0 -4.5,4.2",
    fill: "none",
    stroke: "#558B2F",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFernsMosses);
export default __webpack_public_path__ + "static/media/ferns_mosses.e7e70fd49e600817a0385362d6a73932.svg";
export { ForwardRef as ReactComponent };